import { getMediaUrl, resolveImageKitUrl } from './mediaUtils';

export const PROVIDER_LABELS = {
  gemini: 'Gemini',
  chatgpt: 'ChatGPT'
};

export const REVIEW_SOURCES = {
  generated: 'generated',
  reported: 'reported'
};

export const getReviewSource = (review) => (
  review?.reviewSource === REVIEW_SOURCES.reported ? REVIEW_SOURCES.reported : REVIEW_SOURCES.generated
);

export const getCandidateState = (candidate) => {
  if (!candidate) return 'missing';
  if (candidate.status === 'generated' && candidate.imageUrl) return 'generated';
  return 'failed';
};

export const getReviewCandidateImageUrl = (candidate, imagekitEndpoint) => {
  if (getCandidateState(candidate) !== 'generated') return '';
  return resolveImageKitUrl(candidate.imageUrl, imagekitEndpoint);
};

export const countGeneratedCandidates = (review) => {
  const candidates = review?.candidates || {};
  return ['gemini', 'chatgpt'].filter((provider) => getCandidateState(candidates[provider]) === 'generated').length;
};

export const getReportedMediaUrl = (review, imagekitEndpoint, workerBase) => {
  if (getReviewSource(review) !== REVIEW_SOURCES.reported) return '';
  const mediaUrl = review?.reportedMediaUrl || review?.reportedImageUrl;
  return review?.reportedMediaType === 'video'
    ? getMediaUrl(mediaUrl, workerBase)
    : resolveImageKitUrl(mediaUrl, imagekitEndpoint);
};

export const getReportedImageUrl = getReportedMediaUrl;
